export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 18"
      width={24}
      height={18}
    >
      <path
        fill="url(#a)"
        stroke="url(#b)"
        d="M19.314.5q.411.001.801.146.308.117.572.326l.17.146.005.006.006.005 1.091 1.099.002.002c.217.222.384.474.485.757q.142.39.142.797-.002.412-.15.803a2.1 2.1 0 0 1-.478.74l-.004.004-11.355 11.356-.002.002c-.218.215-.468.38-.75.482a2.3 2.3 0 0 1-.796.142q-.407-.001-.796-.142a2.05 2.05 0 0 1-.75-.482l-.001-.002-6.375-6.375-.003-.003a2.1 2.1 0 0 1-.479-.739 2.27 2.27 0 0 1 0-1.615l.09-.203q.15-.296.39-.538l.002-.002 1.092-1.09c.22-.221.471-.39.754-.495q.39-.145.801-.146.41.001.801.146c.28.104.53.27.746.485L9.053 9.84l8.709-8.708c.217-.217.466-.382.748-.485Q18.902.5 19.313.5Zm-9.9 12.818-.354.354-.354-.353-4.934-4.928-.363.362L9.053 14.4 19.672 3.782l-.364-.365z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="11.544"
          x2="11.544"
          y1="1"
          y2="16.813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fcde41" />
          <stop offset=".5" stopColor="#f7c613" />
          <stop offset="1" stopColor="#eeb406" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="11.544"
          x2="11.544"
          y1="1"
          y2="16.813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fcde41" />
          <stop offset=".5" stopColor="#f7c613" />
          <stop offset="1" stopColor="#eeb406" />
        </linearGradient>
      </defs>
    </svg>
  );
};
